/* eslint-disable @typescript-eslint/no-explicit-any */ //TODO
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CorsSecurityInterceptor } from '@eui/core';

@Injectable()
export class CustomCorsInterceptor extends CorsSecurityInterceptor {
    override intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isGisco = request.url.startsWith('https://gisco-services.ec.europa.eu');

        return next.handle(
            request.clone({
                withCredentials: !isGisco,
            })
        );
    }
}
